import { __rest } from "tslib";
import React, { forwardRef, useContext, useEffect, useRef, } from 'react';
import styled from 'styled-components';
import { useMergeRefs } from 'use-callback-ref';
import { isOverflowActive } from './isOverflowActive';
import { OverflowContext } from './OverflowContext';
const Root = styled.span.attrs({ 'data-test': 'text-content' }) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;
/**
 * It adds default ellipsis styling
 * It gives tooltip a possibility to check if overflow happens inside any nested children
 */
// eslint-disable-next-line react/display-name
export const OverflowTrigger = forwardRef((_a, externalRef) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const overflowContextSet = useContext(OverflowContext);
    const ref = useRef(null);
    const mergedRefs = useMergeRefs([ref, externalRef]);
    if (!overflowContextSet) {
        throw new Error('OverflowTrigger should be placed inside Tooltip.');
    }
    useEffect(() => {
        const isCurrentOverflowActive = () => Boolean(ref.current && isOverflowActive(ref === null || ref === void 0 ? void 0 : ref.current));
        overflowContextSet.add(isCurrentOverflowActive);
        return () => {
            overflowContextSet.delete(isCurrentOverflowActive);
        };
    }, [overflowContextSet, ref]);
    return (React.createElement(Root, Object.assign({}, rest, { ref: mergedRefs }), children));
});
//# sourceMappingURL=OverflowTrigger.js.map